// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__xJRcw","contentBlock":"Summary_contentBlock__GWAux","propertyName":"Summary_propertyName__ZBPdx"};